import SurveyFormat from './surveyFormatEnum';
import {
  SurveyQuestionListQm,
  SurveyPageList,
  SurveyThemeVersion,
  GetCurrentSurveySessionQuery,
  SurveyTitleHorizontalAlignment,
  SurveyLogoSize,
  SurveyLogoAlignment,
} from '~lib/generatedGqlTypes';

type Survey = GetCurrentSurveySessionQuery['surveyTakingSession']['survey'] | undefined;

export type ExtrapolateSurveyData = {
  isAutoScroll?: boolean;
  isFooterEnabled?: boolean | null;
  isProgressBarEnabled?: boolean | null;
  isQuestionNumberingEnabled?: boolean;
  isSurveyTitleEnabled?: boolean;
  langCode?: string;
  logo?: {
    enabled?: boolean;
    size?: SurveyLogoSize | null;
    height?: number | null;
    width?: number | null;
    verticalAlignment?: SurveyLogoAlignment | null;
    imageUrl?: string | null;
    description?: string | null;
  };
  totalPages?: number;
  questions?: SurveyQuestionListQm['items'];
  showPageTitles?: boolean;
  showRequiredQuestionAsterisks?: boolean;
  surveyPages?: SurveyPageList['items'];
  surveyTitle?: string;
  surveyTitleAlignment?: SurveyTitleHorizontalAlignment;
  surveyTitleHTML?: string;
  themeVersion?: SurveyThemeVersion;
  totalQuestionsCount?: number;
  labels?: {
    previous?: string;
    next?: string;
    done?: string;
    exit?: string;
  };
};

export const extrapolateSurveyData = (survey: Survey): ExtrapolateSurveyData => {
  if (!survey || Object.entries(survey).length === 0) {
    return {};
  }

  return {
    isAutoScroll: survey.format === SurveyFormat.OQAAT,
    isFooterEnabled: survey.design?.footer?.enabled,
    isProgressBarEnabled: survey.design?.progressBar?.enabled,
    isQuestionNumberingEnabled: survey.design?.questionNumbering?.enabled,
    isSurveyTitleEnabled: survey.design?.surveyTitle.enabled,
    langCode: survey.language?.code,
    logo: {
      enabled: survey.design?.logo?.enabled,
      size: survey.design?.logo?.size,
      height: survey.design?.logo?.height,
      width: survey.design?.logo?.width,
      verticalAlignment: survey.design?.logo?.verticalAlignment,
      imageUrl: survey.design?.logo?.image?.url,
      description: survey.design?.logo?.image?.description,
    },
    totalPages: survey.pages?.totalCount,
    showPageTitles: survey.design?.showPageTitles,
    showRequiredQuestionAsterisks: survey.design?.showRequiredQuestionAsterisks,
    surveyTitle: survey.title,
    surveyTitleAlignment: survey.design?.surveyTitle.horizontalAlignment,
    surveyTitleHTML: survey.titleHTML,
    themeVersion: survey.design?.theme?.version,
    totalQuestionsCount: survey.questionCount,
    labels: {
      previous: survey.navigation?.previous.label,
      next: survey.navigation?.next.label,
      done: survey.navigation?.done.label,
      exit: survey.navigation?.exit?.label,
    },
  };
};

export default extrapolateSurveyData;
